function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#721B00",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M39.5,1 C18.2370835,1 1,18.2370835 1,39.5 C1,60.7629165 18.2370835,78 39.5,78 C60.7629165,78 78,60.7629165 78,39.5 C78,18.2370835 60.7629165,1 39.5,1 Z M0,39.5 C0,17.684784 17.684784,0 39.5,0 C61.315216,0 79,17.684784 79,39.5 C79,61.315216 61.315216,79 39.5,79 C17.684784,79 0,61.315216 0,39.5 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32 26 29 26 29 53 32 53 32 26ZM28 25 28 54 33 54 33 25 28 25ZM50 26 47 26 47 53 50 53 50 26ZM46 25 46 54 51 54 51 25 46 25Z"
}));

function SvgPauseButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseButton);
export default __webpack_public_path__ + "static/media/pause-button.6c8ec6a9.svg";
export { ForwardRef as ReactComponent };